import Vue from 'vue'
import router from '@/router'
import FireErrors from '@/services/fireErrors'
import Validation from '@/services/validation'
import SendingLoader from '@/components/core/SendingLoader'
import GettingLoader from '@/components/core/GettingLoader'
import UserAvatar from '@/components/core/UserAvatar'
import GroupAvatar from '@/components/core/GroupAvatar'
import DiagRemove from '@/components/core/dialogs/DiagRemove'
import DiagInfo from '@/components/core/dialogs/DiagInfo'
import HeadRoot from '@/components/core/HeadRoot'
import HeadIntern from '@/components/core/HeadIntern'
import SimpleTitle from '@/components/core/titlecards/SimpleTitle'
import Vue2Editor from "vue2-editor";
import VueGtm from 'vue-gtm';

import VueCroppie from 'vue-croppie'
import 'croppie/croppie.css'


Vue.component('SimpleTitle', SimpleTitle)
Vue.component('SendingLoader', SendingLoader)
Vue.component('GettingLoader', GettingLoader)
Vue.component('UserAvatar', UserAvatar)
Vue.component('GroupAvatar', GroupAvatar)
Vue.component('DiagRemove', DiagRemove)
Vue.component('DiagInfo', DiagInfo)
Vue.component('HeadRoot', HeadRoot)
Vue.component('HeadIntern', HeadIntern)
Vue.use(VueCroppie)
Vue.use(Vue2Editor)

Vue.use(VueGtm, {
    id: 'GTM-WRTH8T3',
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
})


Vue.mixin({
    computed: {
        user() {
            return this.$store.getters.user;
        }
    },
    methods: {
        getFireError(error) {
            return FireErrors.get(error);
        },
        validateIsEmpty(item) {
            return Validation.isEmpty(item);
        },
        validateIsEmail(item) {
            return Validation.isEmail(item);
        },
        validateIsPwdSafe(item) {
            return Validation.isPwdSafe(item);
        },
        validateDateInFuture(item) {
            return Validation.dateInFuture(item);
        },
        formatAmount(b) {
            let temp = Number(b);
            return temp.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
        },
        permission(item) {
            if (item.allowed == undefined)  return true;
            
            for (let p in item.allowed) {
                for (let key in this.user.role) {
                    if (p === key) {
                        return true;
                    }
                }
            }

            return false;
        }
    }
})